import { type JSX } from "react";
import LoadingCube from "shared-ui/src/components/LoadingCube";

const Loading = (): JSX.Element => {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <LoadingCube />
    </div>
  );
};

export default Loading;
